import React from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import Router from './router';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token，影响范围大
          colorPrimary: '#4ade80',
          borderRadius: 2,

          // 派生变量，影响范围小
          colorBgContainer: '#ffffff'
        },
        components: {
          Layout: {
            bodyBg: '#ffffff00',
            headerBg: '#ffffff',
          },
        }
      }}
    >
      <AntdApp>
        <Router />
      </AntdApp>
    </ConfigProvider>

  );
}

export default App;